<template>
<div class="slider-all-collection">
  <div class="slider-all-collection__title h5 semibold">3D-проект в коллекциях</div>
  <div class="slider-all-collection__tags">
    <nuxt-link
      v-for="(tag, index) in tags"
      :to="tag.link"
      :key="`tag-${ index }`"
      :class="{'active': Boolean(index === activeIndex)}"
      target="_blank"
      @click="() => changeSlideIndex(index)"
    >{{ tag.label }}</nuxt-link>
  </div>
  <div class="slider-all-collection__slider slider-images-navigation-button">
    <client-only>
      <swiper
        :modules="[Navigation, Pagination]"
        :loop="true"
        :navigation="true"
        :pagination="true"
        :space-between="5"
        @swiper="initSwiper"
        @slide-change="changeActiveIndex"
      >
        <swiper-slide
          v-for="(collection, index) in slider"
          :key="`product-image-${collection.id}`"
        >
          <div class="collection-in-product__collection">
            <div class="--image">
              <nuxt-img
                :src="String(collection.image_id)"
                width="320px"
                height="225px"
                fit="cover"
                :alt="`collection-${collection.id}-image-${collection.image_id}`"
              />
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </client-only>
  </div>
  <div class="slider-all-collection__link">
    <div v-if="linkToCollection" class="--link">
      <nuxt-link :to="linkToCollection" target="_blank">
        Показать всю коллекцию
      </nuxt-link>
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
import { type ComputedRef, ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation } from 'swiper/modules';

const props = defineProps({
  project: {
    type: Object,
    default: () => {
      return {}
    }
  }
});

const tags: any = computed(() => {
  return [...(props.project?.products || [])]
    .map((t: any) => {
      return {
        label: t?.name,
        link: t?.url || ""
      }
    })
});
const slider: any = computed(() => {
  return [...(props.project?.products || [])]
});

const refSwiper: Ref<any> = ref(null);
const initSwiper = (item: any) => {
  refSwiper.value = item;
};

const activeIndex: Ref<number> = ref(0);
const changeActiveIndex = (item: any) => {
  activeIndex.value = item?.realIndex || 0;
};
const changeSlideIndex = (index: number) => {
  refSwiper.value.slideToLoop(index);
};
const linkToCollection: ComputedRef<string> = computed(() => {
  return tags.value?.[activeIndex.value]?.link
});
</script>

<style lang="scss">
.slider-all-collection {}
.slider-all-collection__title {
  margin-bottom: 10px;
}
.slider-all-collection__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;

  & > * {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 20px 7px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
    background: #F4F3F1;

    font-size: 12px;
    line-height: 14px;
    color: #000000;
    font-weight: 500;

    &:hover, &.active {
      background: #ECE2C9;
    }
  }
}
.slider-all-collection__slider {
  position: relative;
  overflow: hidden;
  border-radius: 10px;

  .swiper-button-next, .swiper-button-prev {
    opacity: 0;
  }
  .swiper-pagination-bullet {
    background-color: white;
    opacity: 0;
    width: 5px;
    height: 5px;
  }
  .swiper-pagination-bullet-active {
    opacity: 0;
  }

  &:hover {
    .swiper-pagination-bullet {
      opacity: 0.5;
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
    }
    .swiper-button-next, .swiper-button-prev {
      opacity: 1;
    }
  }
}
.slider-all-collection__link {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 10px;

  a {
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    text-decoration-line: underline;
    transition: all 0.2s;
    color: #404040;

    &:hover {
      text-decoration-color: transparent;
    }
  }
}

@media (max-width: 1023px) {
  .slider-all-collection__slider {
    .swiper-pagination-bullet {
      opacity: 0.5;
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
    }
    .swiper-button-next, .swiper-button-prev {
      opacity: 1;
    }
  }
}
</style>
